import { Unstable_Grid2 as Grid } from '@mui/material';

import { offerFundingSourceOptions } from '@occc-app/routes/CampaignComponents/components/MarketingContent/consts';
import { Select, Typography, TextField } from '@occc-app/design-system';

import { MarketingContentFormValuesPaths } from './types';
import { OfferTrackingSection } from './OfferTrackingSection';

export const OfferFundingDesignSection = () => {
  return (
    <Grid container spacing={3}>
      <Grid xs={12}>
        <Typography variant='subtitle1'>Offer Funding</Typography>
      </Grid>

      <Grid xs={12} sm={3}>
        <Select
          name={'offer.fundingSource' satisfies MarketingContentFormValuesPaths}
          label='Offer Funding Source'
          data={offerFundingSourceOptions}
          formControlProps={{ size: 'medium' }}
        />
      </Grid>

      <Grid xs={12} sm={3}>
        <TextField
          name={'offer.fundingSourceName' satisfies MarketingContentFormValuesPaths}
          label='Funding Source Name'
        />
      </Grid>

      <Grid xs={12}>
        <OfferTrackingSection />
      </Grid>
    </Grid>
  );
};
